module.exports = __webpack_public_path__ + "static/media/after_squid.742e994a.mp3";